import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  Card,
  Typography,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import { Box, Flex } from 'rebass';
import Filter from '../../../components/Filter';
import PieChart from '../../../components/PieChart';
import api from '../../../services/api';

const useStyles = makeStyles((theme) => ({
  root: {
    width: theme.breakpoints.values.lg,
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3),
  },
  top: {
    flexGrow: 1,
    backgroundColor: 'text',
    paddingBottom: '15px',
  },
  title: {
    paddingLeft: '40px',
    paddingTop: '25px',
    flexGrow: 1,
    backgroundColor: '#f9f9fc',
  },
  container: {
    marginTop: theme.spacing(3),
  },
  barChartIcon: {
    marginRight: theme.spacing(1),
  },
  circularProgress: {
    margin: '20px',
  },
}));

const Defects = () => {
  const classes = useStyles();
  const [filterParams, setFilterParams] = useState({});
  const [data, setData] = useState([]);
  const [selectedLines, setSelectedLines] = useState('');
  const [period, setPeriod] = useState('');
  const [lines, setLines] = useState([]);
  const unity = localStorage.getItem('@icep-app/unity');
  const [progress, setProgress] = useState(true);
  const [subtext, setSubtext] = useState('Este mês');
  const idUser = localStorage.getItem('@icep-app/iduser');

  useEffect(() => {
    async function fetchData() {
      if (!!selectedLines && selectedLines !== '') {
        const resp = await api.get(
          `/spcqualityitems/unity/${unity}/line/${selectedLines}/defects/count/${
            period !== 'thisMonth' ? period : ''
          }`,
        );
        setData(resp.data);
      }
    }
    fetchData();
    setProgress(false);
  }, [selectedLines, unity, period]);

  useEffect(() => {
    async function handleGetLines() {
      const resp = await api.get(`/userlines/${idUser}/unity/${unity}/lines`);
      setLines(resp.data);
      setSelectedLines('');
    }
    handleGetLines();
  }, [idUser, unity]);

  const params = {
    period: 'thisMonth',
    selectedLine: selectedLines,
  };

  const handleFilter = async (item) => {
    handleSubText(item.period);
    setPeriod(item.period ? item.period : params.period);
    // let line_id =
    //   item.selectedLine && item.selectedLine.value
    //     ? item.selectedLine.value
    //     : params.selectedLine;

    let line_ids = item?.selectedLines
      ? item?.selectedLines
      : params.selectedLines;
    setSelectedLines(line_ids);
  };

  const handleSubText = (item) => {
    switch (item) {
      case 'today':
        setSubtext('Hoje');
        break;
      case 'yesterday':
        setSubtext('Ontem');
        break;
      case 'thisMonth':
        setSubtext('Este Mês');
        break;

      default:
        break;
    }
  };

  const handleClear = async () => {
    setFilterParams({ period: filterParams.period });
    setSelectedLines('');
  };

  const getLine = (id) => {
    if (!!selectedLines && selectedLines !== '') {
      if (selectedLines.split(',').length > 1) {
        return 'Múltiplas linhas selecionadas';
      } else {
        var filtered = lines.filter((item) => {
          return item.line_id === parseInt(id);
        });
        return filtered[0]?.line?.description;
      }
    } else {
      return 'Nenhuma linha selecionada';
    }
  };

  return (
    <Grid className={classes.root}>
      <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
        <Grid item>
          <Typography component="h2" gutterBottom variant="overline">
            Ranking de Defeito
          </Typography>
          <Typography component="h1" variant="h3">
            Mês e Dia
          </Typography>
          <Typography variant="body1" color="textPrimary">
            {getLine(selectedLines)}
          </Typography>
        </Grid>
        <Grid item>
          <Filter
            label=" Caixas"
            endpoint="/boxes"
            onClear={handleClear}
            onFilter={handleFilter}
            className={classes.filterButton}
            filterParams={filterParams}
            showLine={false}
            showMultipleLines={true}
          />
        </Grid>
      </Grid>

      {progress ? (
        <Paper className={classes.container}>
          <Box container justifyContent="center" alignItems="center">
            <Flex justifyContent="center" alignItems="center">
              <CircularProgress
                className={classes.circularProgress}
                color="secondary"
              />
            </Flex>
          </Box>
        </Paper>
      ) : (
        <>
          <Grid className={classes.container} justify="space-between" container>
            <Grid item lg={12} xl={12} xs={12}>
              {data && data.length > 0 ? (
                <Card>
                  <PieChart
                    data={data}
                    title="Ranking de Defeito"
                    subtext={subtext}
                  />
                </Card>
              ) : (
                <Card>
                  <Typography
                    align="center"
                    color="textPrimary"
                    variant="body2"
                    className={classes.circularProgress}
                  >
                    Sem dados
                  </Typography>
                </Card>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Defects;
